import React from "react";
import HeaderWithSearch from "./HeaderWithSearch";
import ImageWithFallback from "./ImageWithFallback";

function MixVegetableCurry() {
  return (
    <>
      <HeaderWithSearch />
      <main
        style={{
          minHeight: "100vh",
          width: "100%",
          background: "linear-gradient(180deg, #e3f0fc 0%, #fafdff 100%)",
          padding: 0,
          margin: 0,
        }}
      >
        <section
          className="recipe-hero-anim"
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "60vh",
            padding: "60px 20px 40px 20px",
          }}
        >
          <h1
            className="recipe-title-anim"
            style={{
              fontSize: "3rem",
              fontWeight: "bold",
              marginBottom: 16,
              textAlign: "center",
            }}
          >
            Mix Vegetable Curry
          </h1>
          <span className="season-badge season-winter" style={{ marginBottom: 24 }}>❄️ Best in Winter</span>
          <ImageWithFallback
            src="/mix_vegetable_curry.jpg"
            alt="Mix Vegetable Curry"
            className="recipe-image-anim"
            style={{
              width: 400,
              height: 300,
              objectFit: "cover",
              borderRadius: 24,
              boxShadow: "0 4px 32px rgba(0,0,0,0.10)",
              marginBottom: 32,
            }}
          />
          <div
            style={{
              maxWidth: 800,
              fontSize: "1.1rem",
              color: "#333",
              lineHeight: 1.8,
            }}
          >
            <h2 style={{ fontSize: "1.5rem", fontWeight: 600, marginBottom: 16 }}>
              Ingredients:
            </h2>

            <h3 style={{ fontSize: "1.3rem", fontWeight: 600, marginTop: 16, marginBottom: 12 }}>
              Main Vegetables:
            </h3>
            <ul className="ingredient-list" style={{ marginBottom: 20, paddingLeft: 20 }}>
              <li>1 carrot, chopped</li>
              <li>1/2 cup beans, chopped</li>
              <li>1 cup cauliflower florets</li>
              <li>2 tomatoes, chopped</li>
              <li>1/2 cup peas</li>
              <li>1/2 capsicum (bell pepper), chopped</li>
            </ul>

            <h3 style={{ fontSize: "1.3rem", fontWeight: 600, marginBottom: 12 }}>
              For Frying Vegetables:
            </h3>
            <ul className="ingredient-list" style={{ marginBottom: 20, paddingLeft: 20 }}>
              <li>Oil for frying</li>
              <li>1 tsp salt</li>
              <li>1/2 tsp turmeric powder</li>
            </ul>

            <h3 style={{ fontSize: "1.3rem", fontWeight: 600, marginBottom: 12 }}>
              Masala Mix:
            </h3>
            <ul className="ingredient-list" style={{ marginBottom: 20, paddingLeft: 20 }}>
              <li>1 tsp coriander powder</li>
              <li>1 tsp red chilli powder</li>
              <li>1 tsp turmeric powder</li>
              <li>Water (as needed)</li>
            </ul>

            <h3 style={{ fontSize: "1.3rem", fontWeight: 600, marginBottom: 12 }}>
              For Final Curry:
            </h3>
            <ul className="ingredient-list" style={{ marginBottom: 24, paddingLeft: 20 }}>
              <li>2 tbsp oil</li>
              <li>1 tsp cumin seeds</li>
              <li>1 tsp salt</li>
              <li>1 tsp ginger green chilli paste</li>
              <li>1 tsp kasuri methi (dried fenugreek leaves)</li>
              <li>1/2 tsp garam masala</li>
              <li>Fresh coriander leaves for garnish</li>
              <li>Water (as needed)</li>
            </ul>

            <h2 style={{ fontSize: "1.5rem", fontWeight: 600, marginBottom: 16 }}>
              Instructions:
            </h2>
            <ol className="instructions-list" style={{ paddingLeft: 20 }}>
              <li style={{ marginBottom: 12 }}>
                <strong>Prepare vegetables:</strong> Wash and chop all the vegetables - carrot, beans, cauliflower, tomatoes, and capsicum into bite-sized pieces.
              </li>
              <li style={{ marginBottom: 12 }}>
                <strong>Fry vegetables:</strong> Heat oil in a pan. Add chopped carrot, beans, and cauliflower. Add 1 tsp salt and 1/2 tsp turmeric powder. Fry the vegetables until they are slightly tender and golden. Set aside.
              </li>
              <li style={{ marginBottom: 12 }}>
                <strong>Prepare masala paste:</strong> In a small bowl, mix together 1 tsp coriander powder, 1 tsp red chilli powder, and 1 tsp turmeric powder with a little water to make a smooth paste.
              </li>
              <li style={{ marginBottom: 12 }}>
                <strong>Start the curry:</strong> Heat 2 tbsp oil in a large pan or kadhai. Add 1 tsp cumin seeds and let them splutter.
              </li>
              <li style={{ marginBottom: 12 }}>
                <strong>Add aromatics:</strong> Add 1 tsp ginger green chilli paste and sauté for a few seconds until fragrant.
              </li>
              <li style={{ marginBottom: 12 }}>
                <strong>Cook tomatoes:</strong> Add the 2 chopped tomatoes and cook until they become soft and mushy, about 3-4 minutes.
              </li>
              <li style={{ marginBottom: 12 }}>
                <strong>Add masala:</strong> Add the prepared masala paste and cook for 2 minutes, stirring continuously. Add a little water if needed to prevent sticking.
              </li>
              <li style={{ marginBottom: 12 }}>
                <strong>Add vegetables:</strong> Add the fried vegetables (carrot, beans, cauliflower), peas, and chopped capsicum. Mix well to coat with the masala.
              </li>
              <li style={{ marginBottom: 12 }}>
                <strong>Season and simmer:</strong> Add 1 tsp salt, kasuri methi, and water as needed to achieve desired gravy consistency. Cover and cook for 5-7 minutes until all vegetables are tender.
              </li>
              <li style={{ marginBottom: 12 }}>
                <strong>Finish:</strong> Add 1/2 tsp garam masala and mix well. Cook for another minute.
              </li>
              <li style={{ marginBottom: 12 }}>
                <strong>Garnish and serve:</strong> Garnish with fresh coriander leaves. Serve hot with roti, naan, or rice.
              </li>
            </ol>

            <div
              className="chef-tips-box"
              style={{
                background: "#f8f9fa",
                padding: 20,
                borderRadius: 12,
                marginTop: 24,
              }}
            >
              <h3 style={{ fontSize: "1.3rem", fontWeight: 600, marginBottom: 12 }}>
                <span className="tip-icon" role="img" aria-label="chef">👨‍🍳</span> Chef's Tips:
              </h3>
              <ul style={{ paddingLeft: 20 }}>
                <li>Frying vegetables first adds extra flavor and texture</li>
                <li>Adjust water quantity based on whether you prefer thick or thin gravy</li>
                <li>You can add potatoes for a heartier curry</li>
                <li>Kasuri methi adds authentic restaurant-style flavor</li>
                <li>Don't overcook vegetables - they should retain some bite</li>
              </ul>
            </div>

            <div
              className="health-benefits-box"
              style={{
                background: "#eef9f0",
                padding: 20,
                borderRadius: 12,
                marginTop: 24,
              }}
            >
              <h3 style={{ fontSize: "1.3rem", fontWeight: 600, marginBottom: 12 }}>
                <span className="tip-icon" role="img" aria-label="health">🌿</span> Health Benefits
              </h3>
              <ul style={{ paddingLeft: 20 }}>
                <li>A mix of carrots, beans, cauliflower, and peas provides a wide range of vitamins and fiber in one dish.</li>
                <li>Turmeric and cumin bring anti-inflammatory compounds to the gravy.</li>
                <li>A naturally vegetarian, protein-light main that's easy to pair with lentils for a complete meal.</li>
                <li>Cooking vegetables just until tender helps them keep more of their nutrients.</li>
              </ul>
            </div>
          </div>
        </section>
      </main>
    </>
  );
}

export default MixVegetableCurry;